const prefix = "undelivered";

export const thunkTypes = {
  LIST: `${prefix}/list`,
  LIST_GEO_CATALOG: `${prefix}/listGeoCatalog`,
  ADD_ADDRESS: `${prefix}/addAddress`,
  LIST_ADDRESSES: `${prefix}/listAddresses`,
  LOAD_CASE: `${prefix}/loadCase`,
  LIST_CONTACT_LOGS: `${prefix}/listContactLogs`,
  LOG_CONTACT: `${prefix}/logContact`,
  RECONFIRM: `${prefix}/reconfirm`,
  REJECT: `${prefix}/reject`,
  REOPEN: `${prefix}/reopen`,
};
